<script>
  export let item;

  let imk_base_url = "//www.institutional-money.com/content/kgv/bilder/";
  let imk_logo_online_filename = imk_base_url + item.imk_logo_online_filename;
  let ansprechpartner1_filename = imk_base_url + item.ansprechpartner1_filename;
  let ansprechpartner2_filename = imk_base_url + item.ansprechpartner2_filename;
  let ansprechpartner3_filename = imk_base_url + item.ansprechpartner3_filename;
  let ansprechpartner4_filename = imk_base_url + item.ansprechpartner4_filename;

  let ansprechpartner1Name = "";
  if (item.av_nachname1 != "") {
    if (item.av_titel1 != "") {
      ansprechpartner1Name += item.av_titel1 + " ";
    }
    ansprechpartner1Name += item.av_vorname1 + " " + item.av_nachname1;
  }
  let ansprechpartner2Name = "";
  if (item.av_nachname2 != "") {
    if (item.av_titel2 != "") {
      ansprechpartner2Name += item.av_titel2 + " ";
    }
    ansprechpartner2Name += item.av_vorname2 + " " + item.av_nachname2;
  }
  let ansprechpartner3Name = "";
  if (item.av_nachname3 != "") {
    if (item.av_titel3 != "") {
      ansprechpartner3Name += item.av_titel3 + " ";
    }
    ansprechpartner3Name += item.av_vorname3 + " " + item.av_nachname3;
  }
  let ansprechpartner4Name = "";
  if (item.av_nachname4 != "") {
    if (item.av_titel4 != "") {
      ansprechpartner4Name += item.av_titel4 + " ";
    }
    ansprechpartner4Name += item.av_vorname4 + " " + item.av_nachname4;
  }
</script>

{#if item.isPremium}
  <div class="my-4 items-center justify-between gap-4 sm:flex">
    <figure>
      <img src={imk_logo_online_filename} alt={item.firmenname_IMK_AV} />
    </figure>
    <h1 class="text-xl font-bold text-theme-signal">{item.firmenname_IMK_AV}</h1>
  </div>
{:else}
  <h1 class="mb-4 text-xl font-bold text-theme-signal">{item.firmenname_IMK_AV}</h1>
{/if}

{#if item.av_ort}
  <div class="flex flex-wrap justify-between gap-2">
    <h2 class="inline font-bold">Adresse:</h2>
    <div class="mb-1 hidden flex-grow border-b border-im-brown-400 sm:block"></div>
    <address class="ml-auto mt-auto text-end not-italic text-im-brown-600">
      {item.av_strasse}, {item.av_plz}
      {item.av_ort}
    </address>
  </div>
{/if}
{#if item.av_telefon}
  <div class="flex flex-wrap justify-between gap-2">
    <h2 class="mt-4 font-bold">Telefon:</h2>
    <div class="mb-1 hidden flex-grow border-b border-im-brown-400 sm:block"></div>
    <a href={"tel:" + item.av_telefon} class="ml-auto mt-auto text-im-brown-600 underline hocus:no-underline">{item.av_telefon}</a>
  </div>
{/if}
{#if item.av_fax != "//" && item.av_fax != ""}
  <div class="flex flex-wrap justify-between gap-2">
    <h2 class="mt-4 font-bold">Fax:</h2>
    <div class="mb-1 ml-auto hidden flex-grow border-b border-im-brown-400 sm:block"></div>
    <p class="mt-auto text-im-brown-600">{item.av_fax}</p>
  </div>
{/if}
{#if item.av_email}
  <div class="flex flex-wrap justify-between gap-2">
    <h2 class="mt-4 font-bold">E-Mail:</h2>
    <div class="mb-1 hidden flex-grow border-b border-im-brown-400 sm:block"></div>
    <a href="mailto:{item.av_email}" class="ml-auto mt-auto text-im-brown-600 underline hocus:no-underline">{item.av_email}</a>
  </div>
{/if}
{#if item.av_url || item.av_url2}
  <div class="flex flex-wrap justify-between gap-2">
    <h2 class="mt-4 font-bold">Internet:</h2>
    <div class="mb-1 hidden flex-grow border-b border-im-brown-400 sm:block"></div>
    <ul class="ml-auto mt-auto text-im-brown-600">
      {#if item.av_url}
        <li class="mt-auto"><a href="https://{item.av_url}" target="_blank" rel="noreferrer" class="mt-auto underline hocus:no-underline">{item.av_url}</a></li>
      {/if}
      {#if item.av_url2}
        <li class="mt-auto"><a href="https://{item.av_url2}" target="_blank" rel="noreferrer" class="mt-auto underline hocus:no-underline">{item.av_url2}</a></li>
      {/if}
    </ul>
  </div>
{/if}
{#if item.av_nachname1 || item.av_nachname2 || item.av_nachname3 || item.av_nachname4}
  {#if item.av_nachname2}
    <div class="mt-4">
      <h2 class="mt-4 inline font-bold">Ansprechpartner:</h2>
      {#if item.av_nachname1}
        <span class="text-im-brown-600">
          <span class="font-extrabold">
            {item.av_titel1}
            {item.av_vorname1}
            {item.av_nachname1}</span
          >{#if item.av_position1}, {item.av_position1}{/if}
        </span>
      {/if}
      {#if item.av_nachname2}
        <span class="text-im-brown-600">
          <span class="font-extrabold">
            |
            {item.av_titel2}
            {item.av_vorname2}
            {item.av_nachname2}</span
          >{#if item.av_position2}, {item.av_position2}{/if}
        </span>
      {/if}
      {#if item.av_nachname3}
        <span class="text-im-brown-600">
          <span class="font-extrabold">
            |
            {item.av_titel3}
            {item.av_vorname3}
            {item.av_nachname3}</span
          >{#if item.av_position3}, {item.av_position3}{/if}
        </span>
      {/if}
      {#if item.av_nachname4}
        <span class="text-im-brown-600">
          <span class="font-extrabold">
            |
            {item.av_titel4}
            {item.av_vorname4}
            {item.av_nachname4}</span
          >{#if item.av_position4}, {item.av_position4}{/if}
        </span>
      {/if}
    </div>
  {:else if item.av_nachname1}
    <div class="mt-4 flex flex-wrap justify-between gap-2 sm:flex-nowrap">
      <h2 class="font-bold sm:inline">Ansprechpartner:</h2>
      <div class="flex flex-grow justify-between gap-2">
        {#if item.av_nachname1}
          <span class="mr-auto text-im-brown-600">
            <span class="font-extrabold">
              {item.av_titel1}
              {item.av_vorname1}
              {item.av_nachname1}</span
            >{#if item.av_position1}, {item.av_position1}{/if}</span
          >
        {/if}
        {#if item.ansprechpartner1_filename}
          <figure class="max-w-[80px] shrink-0">
            <img src={ansprechpartner1_filename} width="80" alt={ansprechpartner1Name} class="rounded-md drop-shadow-md" />
          </figure>
        {/if}
      </div>
    </div>
  {/if}
{/if}

{#if item.isPremium}
  <h2 class="sr-only">Beschreibung</h2>
  <div class="prose mt-8 max-w-none">
    <div class="not-prose mx-auto mb-3 flex flex-wrap justify-around gap-2 text-sm empty:hidden sm:ml-3">
      {#if item.ansprechpartner2_filename}
        {#if item.ansprechpartner1_filename}
          <figure class="max-w-[80px]">
            <img src={ansprechpartner1_filename} width="80" alt={ansprechpartner1Name} class="rounded-md drop-shadow-md" />
            <figcaption class="mt-0.5 text-center font-bold text-im-brown-600">{item.ansprechpartner1_titel}</figcaption>
          </figure>
        {/if}
        {#if item.ansprechpartner2_filename}
          <figure class="max-w-[80px]">
            <img src={ansprechpartner2_filename} width="80" alt={ansprechpartner2Name} class="rounded-md drop-shadow-md" />
            <figcaption class="mt-0.5 text-center font-bold text-im-brown-600">{item.ansprechpartner2_titel}</figcaption>
          </figure>
        {/if}
        {#if item.ansprechpartner3_filename}
          <figure class="max-w-[80px]">
            <img src={ansprechpartner3_filename} width="80" alt={ansprechpartner3Name} class="rounded-md drop-shadow-md" />
            <figcaption class="mt-0.5 text-center font-bold text-im-brown-600">{item.ansprechpartner3_titel}</figcaption>
          </figure>
        {/if}
        {#if item.ansprechpartner4_filename}
          <figure class="max-w-[80px]">
            <img src={ansprechpartner4_filename} width="80" alt={ansprechpartner4Name} class="rounded-md drop-shadow-md" />
            <figcaption class="mt-0.5 text-center font-bold text-im-brown-600">{item.ansprechpartner4_titel}</figcaption>
          </figure>
        {/if}
      {/if}
    </div>

    {#if item.portrait_online_html != "" && item.portrait_online_html != "<html />"}<p>{@html item.portrait_online_html}</p>{/if}
  </div>
{/if}
